export default "__VITE_ASSET__Y2Zm86ht__"